<template>
  <div v-if="errorMessages && errorMessages.length > 0" class="alert alert-danger" role="alert">
    <ul style="margin-bottom: 0px;">
      <li v-for="(errorMessage, index) in errorMessages" :key="index">
        {{ errorMessage }}
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  props: {
    errorMessages: {
      required: true,
      type: Array
    }
  },
  data: () => {
    return {}
  }
}
</script>
